import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { RotateCcw } from "lucide-react";
import { ChunkyButton } from "@/components/site/ChunkyButton";
import { Bubbles } from "@/components/site/Bubbles";

const STEPS = [
  { caption: "Uh-oh! Germy is hiding...", germy: "/art/germy-pose-hiding.webp", helper: "/art/soapy-exp-surprised.webp", btn: "Bubble him, Soapy!", bg: "#f3fbe6" },
  { caption: "Soapy makes bubbles! Germy is stuck!", germy: "/art/germy-pose-stuck.webp", helper: "/art/soapy-pose-bubbles.webp", btn: "Scrub, Handy!", bg: "#eaf6ff" },
  { caption: "Bye-bye, Germy!", germy: "/art/germy-pose-washing.webp", helper: "/art/handy-pose-wash.webp", btn: null, bg: "#e0f2fe" },
];

export const HeroVsVillain = () => {
  const [step, setStep] = useState(0);
  const s = STEPS[step];
  return (
    <section data-testid="hero-vs-villain-game" className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
      <div className="relative overflow-hidden rounded-[2.5rem] border-4 border-white p-6 shadow-[0_20px_50px_rgba(11,79,163,0.15)] transition-colors duration-700 sm:p-12" style={{ background: s.bg }}>
        {step > 0 && <Bubbles count={step === 1 ? 10 : 6} />}
        <p className="font-display text-lg font-semibold text-[#7cc61e]">Hero vs. Villain</p>
        <h2 className="font-display text-3xl font-bold text-[#0b4fa3] sm:text-4xl">Help Handy wash Germy away!</h2>
        <div className="relative mt-10 grid items-center gap-6 sm:grid-cols-2">
          <AnimatePresence mode="wait">
            <motion.img key={`g${step}`} src={s.germy} alt="Germy" data-testid={`hvv-germy-step-${step}`}
              initial={{ opacity: 0, scale: 0.7 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.6, rotate: 20 }}
              className={`mx-auto aspect-square w-full max-w-xs rounded-3xl object-contain ${step === 0 ? "peek" : ""}`} />
          </AnimatePresence>
          <AnimatePresence mode="wait">
            <motion.img key={`h${step}`} src={s.helper} alt="Helper" initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -40 }}
              className="mx-auto aspect-square w-full max-w-xs rounded-3xl object-contain" />
          </AnimatePresence>
        </div>
        <p data-testid="hvv-caption" className="relative mt-8 text-center font-display text-2xl font-bold text-[#0b4fa3] sm:text-3xl">{s.caption}</p>
        <div className="relative mt-8 flex justify-center">
          {s.btn ? (
            <ChunkyButton data-testid="hvv-next-button" bg={step === 0 ? "#38a8f0" : "#1e9bf0"} onClick={() => setStep(step + 1)}>{s.btn}</ChunkyButton>
          ) : (
            <ChunkyButton data-testid="hvv-replay-button" bg="#7cc61e" edge="#4d7c0f" onClick={() => setStep(0)}><RotateCcw className="h-5 w-5" /> Play again</ChunkyButton>
          )}
        </div>
      </div>
    </section>
  );
};
